import React, { useEffect, useState } from 'react';
import SectionTitle from '../common/sectionTitle/sectionTitle';
import alert from '../../assests/images/alert.png';
import ModalsPass from './ModalsPass';
import Modals from './Modals';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import './style.scss';
import { resetPasswordSave80iac, resetPasswordValidationSave } from './dependencies/action';

const ResetUserPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleClosePasswordModal = () => {
    setShowPasswordModal(false);
    history.push('/');
  };

  const handleSubmitPasswordModal = () => {
    setShowPasswordModal(false);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    const lastSuccessTime = localStorage.getItem('passwordSuccessTime');
    if (lastSuccessTime) {
      const currentTime = new Date().getTime();
      const timeDifference = currentTime - parseInt(lastSuccessTime, 10);

      if (timeDifference >= 600000) {
        setShowPasswordModal(true);
      }
    } else {
      setShowPasswordModal(true);
    }
  }, []);

  const handleEmailChange = (e) => {
    const inputEmail = e.target.value;
    setEmail(inputEmail);
    if (!validateEmail(inputEmail)) {
      setEmailError('Please Enter a valid email address');
    } else {
      setEmailError('');
    }
  };

  const handlePasswordChange = (e) => {
    const inputPassword = e.target.value;
    setPassword(inputPassword);
    if (!inputPassword) {
      setPasswordError('Please Enter a password');
    } else {
      setPasswordError('');
    }
  };

  const handleSubmit = async () => {
    if (!emailError && email) {
      try {
        const data = { email };
        const res = await dispatch(resetPasswordSave80iac(data));
        handleShow();
        setEmail('');
        setEmailError('');
        handleClose();
      } catch (error) {
        console.error("Reset password error:", error);
      }
    }
  };

  const submitBTNPass = () => {
    if (!passwordError && password) {
      dispatch(resetPasswordValidationSave({ password })).then((res) => {
        if (res.status === true) {
          const currentTime = new Date().getTime();
          localStorage.setItem('passwordSuccessTime', currentTime);

          handleSubmitPasswordModal();
        } else {
          setPassword('');
        }
      });

    } else {
      if (!password) {
        setPasswordError('Please Enter a password');
      }
    }
  };

  const submitBTN = () => {
    if (email && !emailError) {
      handleShow();
    } else {
      if (!email) {
        setEmailError('Please Enter a valid email address');
      }
    }
  };

  return (
    <>
      <ModalsPass
        show={showPasswordModal}
        handleClose={handleClosePasswordModal}
        password={password}
        passwordError={passwordError}
        handlePasswordChange={handlePasswordChange}
        submitBTN={submitBTNPass}
      />

      <div className="changePawword-outer">
        {/* <SectionTitle title={'Reset Password'}>  Reset Password</SectionTitle> */}
        <div className="row mb-bottom-30 d-flex justify-content-center">
          <div className="col-12 col-lg-12">
            <div className="alert" role="alert">
              <img src={alert} alt="alert" /> This reset password functionality is for all parts of the Hub, not only for recognized startups.
            </div>
          </div>
        </div>
        <div className="row mb-50 mb-bottom-30 d-flex justify-content-center">
          <div className="col-12 col-lg-6 mb-bottom-30">
            <div className="stat-block-wrap">
              <div className="stat-header">
                <h5> Reset Password</h5>
              </div>
              <div className="stat-body clearfix d-flex flex-column justify-content-center">
                <div className="form-group">
                  <label htmlFor="emailid">Email ID</label>
                  <input
                    type="email"
                    className="form-control"
                    id="emailid"
                    placeholder="Enter your email id"
                    value={email}
                    onChange={handleEmailChange}
                    autoComplete="off"
                  />
                  {emailError && <div className="text-danger">{emailError}</div>}
                </div>

                <button type="button" className="btn btn-primary" onClick={submitBTN}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modals show={showModal} handleClose={handleClose} handleSubmit={handleSubmit} />
    </>
  );
};

export default ResetUserPassword;